<template>
    <div
        ref="chartDeliveryUnitWarehouse"
        style="width: 100%; height: 500px"
    ></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
    name: "ChartDeliveryUnitWarehouse",
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            chart: null,
        };
    },
    watch: {
        data: {
            handler(newData) {
                this.createChart(newData);
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        findBiggestPercent(data) {
            let total = data.reduce((acc, curr) => acc + curr.jumlah_muat, 0);
            let biggest = data.reduce((acc, curr) =>
                acc.jumlah_muat > curr.jumlah_muat ? acc : curr
            );

            return {
                kode_gudang: biggest.kode_gudang,
                percent: ((biggest.jumlah_muat / total) * 100).toFixed(1),
                jumlah_muat: biggest.jumlah_muat,
            };
        },
        createChart(data) {
            if (this.chart) {
                this.chart.dispose();
            }

            let chart = am4core.create(
                this.$refs.chartDeliveryUnitWarehouse,
                am4charts.PieChart
            );

            const resultData = this.findBiggestPercent(data);

            var label = chart.seriesContainer.createChild(am4core.Label);
            label.text = `${resultData.percent}% \n ${resultData.kode_gudang}`;
            label.horizontalCenter = "middle";
            label.verticalCenter = "middle";
            label.fontSize = 20;

            // Set custom colors before adding data and creating series
            chart.colors.list = [
                am4core.color("#3E8DF3"),
                am4core.color("#F3B343"),
                am4core.color("#EB5464"),
                am4core.color("#7F71B7"),
                am4core.color("#7AAF4B"),
                am4core.color("#C577B4"),
                am4core.color("#D1D1D1"),
                am4core.color("#A7AC1B"),
            ];

            // Add data
            chart.data = data.map((item) => ({
                warehouse: item.kode_gudang || "Unknown",
                loadCount: item.jumlah_muat,
            }));

            // Create series
            let pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "loadCount";
            pieSeries.dataFields.category = "warehouse";
            pieSeries.slices.template.tooltipText = "{category}: {value}";
            pieSeries.innerRadius = am4core.percent(70); // Adjust the percentage to control the size of the hole
            pieSeries.labels.template.relativeRotation = 0;

            pieSeries.slices.template.adapter.add("fill", (fill, target) => {
                return this.chart.colors.getIndex(target.dataItem.index);
            });

            // Remove ticks
            pieSeries.ticks.template.disabled = false;

            // Position labels circularly
            pieSeries.alignLabels = true;

            // Replace label information
            pieSeries.labels.template.text =
                "{value.percent.formatNumber('#.0')}%";

            // Add legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "bottom";
            chart.legend.marginTop = 20;
            chart.legend.useDefaultMarker = true;

            this.chart = chart;
        },
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    },
};
</script>

<style scoped>
#chartDeliveryUnitWarehouse {
    width: 100%;
    height: 500px;
}
</style>
